/*  MUI  */
import { Flex } from '@auviknetworks/iceberg-ui';
import { Box, Paper } from '@mui/material';

/* Shared  */
import { KebabMenu } from 'application/Shared/Components/Menu/KebabMenu';
import { FontSizes } from 'application/Shared/Constants';
import { Route } from 'application/Shared/Helpers';

/*  Helpers */
import { Tenant } from 'application/Shared/types/tenant';

/*  React  */
import React from 'react';

const buildOptions = (tenant: Tenant, partnerTenant?: Tenant) => {
    const options = [];

    if (!tenant.partner) {
        const baseAdminRoute = Route.buildBaseAdminRoute({
            clientId: tenant.id,
            partnerId: partnerTenant?.id
        });

        options.push({
            key: 'viewClient',
            label: 'View Client',
            link: {
                to: baseAdminRoute
            },
            value: 'viewClient'
        });
    }
    if (tenant.partner || partnerTenant) {
        const baseRoute = Route.buildBaseRoute({
            partnerId: tenant?.id || partnerTenant?.id
        });
        options.push({
            key: 'viewPartner',
            label: 'View Partner',
            link: {
                to: baseRoute
            },
            value: 'viewPartner'
        });
    }

    return options;
};

const HeaderActions = ({
    tenant,
    partnerTenant
}: {
    tenant: Tenant;
    partnerTenant?: Tenant;
}) => {
    const options = buildOptions(tenant, partnerTenant);

    return (
        <Flex alignItems="center" justifyContent="flex-end">
            <KebabMenu
                options={options}
                onClick={() => {}}
                data-testid="clientsTableActions"
            />
        </Flex>
    );
};

export const TenantHeader = ({
    tenant,
    partnerTenant
}: {
    tenant: Tenant;
    partnerTenant: Tenant;
}) => (
    <Paper
        elevation={0}
        sx={{
            borderRadius: 0,
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '24px',
            marginLeft: '-16px',
            marginRight: '-16px',
            marginTop: '-16px',
            paddingX: '24px',
            paddingY: '16px'
        }}
    >
        <Box
            display="flex"
            flexDirection="column"
            data-testid="appHeader"
            data-trackid="sharedComponentsHeadersAppHeader"
            sx={{
                color: 'text.primary',
                textTransform: 'none'
            }}
        >
            <Box sx={{ fontSize: FontSizes[4] }}>{tenant.name}</Box>
            <Box sx={{ fontSize: FontSizes[1] }}>ID: {tenant.id}</Box>
        </Box>
        <HeaderActions tenant={tenant} partnerTenant={partnerTenant} />
    </Paper>
);
